"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = (0, _styles.makeStyles)(function (theme) {
  var _roleListbox;

  return {
    root: _defineProperty({
      boxSizing: 'border-box',
      height: 'auto',
      position: 'relative',
      width: 245,
      '& > .carousel': {
        height: '100%',
        width: '100%'
      },
      '& [role="listbox"]': (_roleListbox = {
        height: 'calc(12rem * 3)',
        overflow: 'hidden',
        width: '100%'
      }, _defineProperty(_roleListbox, theme.breakpoints.down('md'), {
        flex: 1,
        height: '12rem'
      }), _defineProperty(_roleListbox, '& ul', {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        transition: 'transform 500ms ease-in'
      }), _roleListbox)
    }, theme.breakpoints.down('md'), {
      width: '100%'
    }),
    stack: _defineProperty({
      flexDirection: 'column'
    }, theme.breakpoints.down('md'), {
      flexDirection: 'row'
    }),
    back: {
      '& button': _defineProperty({
        transform: 'rotate(90deg) translateX(-50%)'
      }, theme.breakpoints.down('md'), {
        transform: 'none'
      }),
      '& svg': {
        width: '2rem',
        height: '2rem'
      }
    },
    next: {
      '& button': _defineProperty({
        transform: 'rotate(90deg) translateX(-50%)'
      }, theme.breakpoints.down('md'), {
        transform: 'none'
      }),
      '& svg': {
        width: '2rem',
        height: '2rem'
      }
    }
  };
});

exports["default"] = _default;